import { useState, useEffect } from 'react';
import useEditorStore, { EditorOperatorEnum } from '@/state/editor-store';
import { EditorOperatorConfigMap } from '../../../module/util';

export const useDurationControl = (operator: EditorOperatorEnum, editor: any) => {
  const [disabled, setDisabled] = useState(false);
  const config = EditorOperatorConfigMap?.[operator];
  const { min, max, default: configDefault, disabled: configDisabled } = config ?? {};

  const { duration, setDuration, setFinalDuration } = useEditorStore((state) => ({
    duration: state.duration,
    setDuration: state.setDuration,
    setFinalDuration: state.setFinalDuration,
  }));

  const updateFinalDuration = (editor: any, setFinalDuration: any) => {
    const iFinalDuration = editor.calcFinalDuration();
    editor.finalDuration = iFinalDuration;
    setFinalDuration(iFinalDuration);
  };

  useEffect(() => {
    if (!editor) return;

    if (operator) {
      const newDuration = configDefault ?? 60;
      setDuration(newDuration);
      editor.currentOperatorDuration = newDuration;
      setDisabled(configDisabled ?? false);
    } else {
      setDuration(60);
      editor.currentOperatorDuration = 60;
      setDisabled(false);
    }
  }, [operator, configDefault, configDisabled]);

  const handleChange = (value: string) => {
    let numValue = parseInt(value, 10);
    if (isNaN(numValue)) numValue = '' as any;
    if (numValue > max) numValue = max;
    setDuration(numValue);
    if (editor) {
      editor.currentOperatorDuration = numValue;
      updateFinalDuration(editor, setFinalDuration);
    }
  };

  const handleBlur = () => {
    if (!editor) return;

    if (duration < min) {
      editor.currentOperatorDuration = min;
      setDuration(min);
      updateFinalDuration(editor, setFinalDuration);
    }
    if (duration > max) {
      editor.currentOperatorDuration = max;
      setDuration(max);
      updateFinalDuration(editor, setFinalDuration);
    }
  };

  const handleDialChange = (value: number) => {
    if (!disabled) {
      setDuration(value);
      updateFinalDuration(editor, setFinalDuration);
    }
  };

  return {
    duration,
    disabled,
    handleChange,
    handleBlur,
    handleDialChange
  };
}; 